import gql from 'graphql-tag'

export const CREATE_CHANNEL = gql`
  mutation CreateChannel(
    $id: Int
    $scope: String!
    $targetId: Int
    $provider: String!
    $channelType: String!
    $phoneNumber: String
    $credentials: JSONString
    $assignedMemberIds: [Int]
    $isActive: Boolean
  ) {
    createChannel(
      id: $id
      scope: $scope
      targetId: $targetId
      provider: $provider
      channelType: $channelType
      phoneNumber: $phoneNumber
      credentials: $credentials
      assignedMemberIds: $assignedMemberIds
      isActive: $isActive
    ) {
      channel {
        id
        provider
        channelType
        phoneNumber
        webhookToken
        assignedMemberIds
        isActive
        credentials
        webhookUrlTwilio
        webhookUrlBotmaker
      }
      success
      error
    }
  }
`

export const DELETE_CHANNEL = gql`
  mutation DeleteChannel($id: Int!) {
    deleteChannel(id: $id) {
      success
      error
    }
  }
`

export const TEST_TWILIO_CREDENTIALS = gql`
  mutation TestTwilioCredentials($accountSid: String!, $authToken: String!) {
    testTwilioCredentials(accountSid: $accountSid, authToken: $authToken) {
      success
      accountName
      error
    }
  }
`

export const UPDATE_DIFY_CONFIG = gql`
  mutation UpdateDifyConfig(
    $scope: String!
    $targetId: Int
    $difyEnabled: Boolean!
    $difyApiKey: String
    $difyApiUrl: String
    $difyAppId: String
    $aiProvider: String
    $llmProvider: String
    $llmApiKey: String
    $llmModel: String
  ) {
    updateDifyConfig(
      scope: $scope
      targetId: $targetId
      difyEnabled: $difyEnabled
      difyApiKey: $difyApiKey
      difyApiUrl: $difyApiUrl
      difyAppId: $difyAppId
      aiProvider: $aiProvider
      llmProvider: $llmProvider
      llmApiKey: $llmApiKey
      llmModel: $llmModel
    ) {
      success
      error
      difyEnabled
      difyApiKey
      difyApiUrl
      difyAppId
      aiProvider
      llmProvider
      llmApiKey
      llmModel
    }
  }
`

export const UPDATE_PROMPT_CONFIG = gql`
  mutation UpdatePromptConfig(
    $scope: String!
    $targetId: Int
    $promptHeader: String
    $promptBody: String
    $promptFooter: String
    $shareContactInfo: Boolean
    $shareQuotes: Boolean
    $sharePolicies: Boolean
    $shareLeads: Boolean
    $shareConsentStatus: Boolean
  ) {
    updatePromptConfig(
      scope: $scope
      targetId: $targetId
      promptHeader: $promptHeader
      promptBody: $promptBody
      promptFooter: $promptFooter
      shareContactInfo: $shareContactInfo
      shareQuotes: $shareQuotes
      sharePolicies: $sharePolicies
      shareLeads: $shareLeads
      shareConsentStatus: $shareConsentStatus
    ) {
      success
      error
      promptHeader
      promptBody
      promptFooter
      shareContactInfo
      shareQuotes
      sharePolicies
      shareLeads
      shareConsentStatus
    }
  }
`

export const GET_PROMPT_CONFIG = gql`
  query GetPromptConfig($scope: String!, $targetId: Int) {
    promptConfig(scope: $scope, targetId: $targetId) {
      promptHeader
      promptBody
      promptFooter
      shareContactInfo
      shareQuotes
      sharePolicies
      shareLeads
      shareConsentStatus
    }
  }
`
